import React, { useState } from 'react';
import { motion } from 'framer-motion';
const applications = [{
  sector: 'CLÍNICAS',
  flow: 'WhatsApp → IA → Calificación → Agenda → Seguimiento'
}, {
  sector: 'INMOBILIARIAS',
  flow: 'Consulta → Propiedad → Calificación → Visita → CRM'
}, {
  sector: 'SERVICIOS PROFESIONALES',
  flow: 'Lead → IA → CRM → Reunión → Seguimiento'
}, {
  sector: 'EDUCACIÓN',
  flow: 'Interés → Programa → Calificación → Asesor → Matrícula'
}, {
  sector: 'E-COMMERCE',
  flow: 'Producto → Consulta → IA → Compra → Postventa'
}, {
  sector: 'SERVICIOS',
  flow: 'Solicitud → IA → Información → Cotización → Seguimiento'
}];
export function Applications() {
  const [activeIdx, setActiveIdx] = useState<number | null>(null);
  return <section id="aplicaciones" className="bg-arena py-[48px] md:py-[72px]" data-id="element-53" data-mp="byw1qdi72fh3">
      <div className="max-w-[1000px] mx-auto px-6 md:px-16" data-id="element-54" data-mp="zp02md40014e">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="mb-10 max-w-[560px]" data-id="element-55" data-mp="14grl00d030jg">
          <span className="block font-body text-[11px] uppercase font-medium text-salvia tracking-[0.15em] mb-4" data-id="element-56" data-mp="2t2zx7d2z7s08">
            UNA ARQUITECTURA. DIFERENTES EMPRESAS.
          </span>
          <h2 className="font-display text-[26px] md:text-[36px] font-medium text-carbon leading-[1.2]" data-id="element-57" data-mp="32ykxn6seck7v">
            La lógica cambia. La capacidad de conectar permanece.
          </h2>
        </motion.div>

        <div className="border-t border-carbon/10" onMouseLeave={() => setActiveIdx(null)} data-id="element-58" data-mp="3br4v43wycir4">
          {applications.map((app, idx) => {
          const isDimmed = activeIdx !== null && activeIdx !== idx;
          return <motion.div key={app.sector} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.3
          }} transition={{
            duration: 0.3,
            ease: 'easeOut',
            delay: idx * 0.04
          }} onMouseEnter={() => setActiveIdx(idx)} onFocus={() => setActiveIdx(idx)} tabIndex={0} className="group flex flex-col sm:flex-row sm:items-center gap-1.5 sm:gap-6 py-4 border-b border-carbon/10 hover:bg-carbon/[0.02] transition-colors duration-200 px-2 outline-none" style={{
            opacity: isDimmed ? 0.4 : 1,
            transition: 'opacity 200ms ease'
          }} data-id="element-59" data-mp="1wae8wvps77oc" data-mpi={idx}>
                <span className="font-body text-[12px] font-semibold uppercase tracking-[0.08em] text-carbon/75 sm:w-[220px] flex-shrink-0" data-id="element-60" data-mp="33yv5fe5oy2a6">
                  {app.sector}
                </span>
                <span className={`font-body text-[13px] transition-colors duration-200 ${activeIdx === idx ? 'text-verde' : 'text-carbon/45'}`} data-id="element-61" data-mp="3dowkxhjzacdh">
                  {app.flow}
                </span>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}